module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chatlab":"Select a user to start a conversation","Sendent":"Send when you press enter","Send":"Send"},"ru":{"chatlab":"Выберите пользователя чтобы начать диалог","Sendent":"Отправлять при нажатии enter","Send":"Отправить"}}')
  delete Component.options._Ctor
}
